<template>
    <modal name="new-artist-modal" transition="pop-out" :width="modalWidth" :focus-trap="true" :height="300" @before-close="beforeClose">

        <div class="box">
                <div class="partition" id="partition-register">
                    <div class="partition-title">CREATE ARTIST</div>
                    <div class="partition-form">
                        <p class="form-text">Use the form below to add a new artist.</p>
                        <form>
                            <label class="sr-only" for="artist-name">Artist Name</label>
                            <input id="artist-name" type="text" placeholder="Artist Name" v-model="artistName">
                        </form>

                        <div style="margin-top: 22px">
                        </div>

                        <div class="button-set">
                            <button id="cancel-btn" @click="cancel">Cancel</button>
                            <button id="create-btn" @click="createArtist">Create</button>
                        </div>

                        <div class="box-messages" v-if="showError">{{ errorMessage }}</div>

                    </div>
                </div>

        </div>


    </modal>
</template>

<script>

import Artists from "@/controllers/artist.controller";

const MODAL_WIDTH = 400
export default {
    name: "NewArtistModal",
    data() {
        return {
            artistID: null,
            artistName: null,
            errorMessage: "",
            showError: false,
            modalWidth: MODAL_WIDTH
        }
    },
    created() {
        this.modalWidth =
            window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH
    },
    methods: {
        cancel() {
            this.$modal.hide('new-artist-modal')
        },
        async createArtist() {

            this.showError = false;
            if (this.artistName === null || this.artistName === '') {
                // If the artist is null or an empty string, give an error.
                this.errorMessage = "Please enter an artist name.";
                this.showError = true;
            } else {
                let artist = await Artists.createNew(this.artistName);
                if (artist === false) {

                    // There was an error adding the artist. Show the user.
                    this.errorMessage = "There was an error adding the artist. Please try again.";
                    this.showError = true;

                } else {
                    this.artistID = artist.id;

                    // Now auto approve the artist.
                    await Artists.approve(this.artistID);

                    // Close the modal which will trigger an event to the page containing the artist ID for
                    // the added artist.
                    this.$modal.hide('new-artist-modal')
                }
            }

        },
        beforeClose(event) {
            this.$emit('artistCreated', {artistID: this.artistID})
        }
    }
}
</script>

<style lang="scss">
$background_color: #404142;
.box {
    background: white;
    overflow: hidden;
    width: 400px;
    height: 300px;
    border-radius: 2px;
    box-sizing: border-box;
    box-shadow: 0 0 40px black;
    color: #8b8c8d;
    font-size: 0;
    .box-messages {
        box-sizing: border-box;
        height: 35px;
        line-height: 32px;
        padding: 0 12px;
        text-align: center;
        width: 100%;
        font-size: 13px;
        color: white;
        background: #FF3636;
        margin-top: 15px;
    }
    .partition {
        width: 100%;
        height: 100%;
        .partition-title {
            box-sizing: border-box;
            padding: 30px;
            width: 100%;
            text-align: center;
            letter-spacing: 1px;
            font-size: 20px;
            font-weight: 300;
            color: #003F4D;
        }
        .partition-form {
            padding: 0 20px;
            box-sizing: border-box;
            color: #003F4D;
            .form-text {
                font-size: 15px;
                color: #003F4D;
            }
            .button-set {
                text-align: center;
            }
        }

    }
    input[type='text'] {
        display: block;
        box-sizing: border-box;
        margin-bottom: 4px;
        width: 100%;
        font-size: 12px;
        line-height: 2;
        border: 0;
        border-bottom: 1px solid #dddedf;
        padding: 4px 8px;
        font-family: inherit;
        transition: 0.5s all;
    }
    button {
        background: white;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 10px;
        letter-spacing: 1px;
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        min-width: 140px;
        margin-top: 8px;
        color: #003F4D;
        cursor: pointer;
        border: 1px solid #dddedf;
        text-transform: uppercase;
        transition: 0.1s all;
        font-size: 10px;
        &:hover {
            border-color: mix(#659772, black, 90%);
            color: mix(#659772, black, 80%);
        }
    }
    .large-btn {
        width: 100%;
        background: white;
        span {
            font-weight: 600;
        }
        &:hover {
            color: white !important;
        }
    }
    .button-set {
        margin-bottom: 8px;
    }
    #create-btn,
    #cancel-btn {
        margin-left: 8px;
    }
    .autocomplete-fix {
        position: absolute;
        visibility: hidden;
        overflow: hidden;
        opacity: 0;
        width: 0;
        height: 0;
        left: 0;
        top: 0;
    }
}
.pop-out-enter-active,
.pop-out-leave-active {
    transition: all 0.5s;
}
.pop-out-enter,
.pop-out-leave-active {
    opacity: 0;
    transform: translateY(24px);
}
</style>